import React from "react";
import { withRouter } from "react-router";
import { DATE_FORMAT, PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import GridFw, { COLUMN_DEFAULT } from '../../../../../framework/grid/GridFw';  
import { MessageUtil } from '../../../../../util/MessageUtil';
import { DatosAnalisisModal } from "../modals/DatosAnalisisModal";
import { Row, Col, Popconfirm } from "antd"; 
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { ICON } from "../../../../../constants/iconConstants";
import { LoadUtil } from "../../../../../framework/util/LoadUtil";
import { EnvConstants } from "../../../../../EnvConstants";

class DatosAnalisisSection extends BasePage {
  renderPage(pageApi) {
    const cambiarTabPanel = pageApi.cambiarTabPanel;
    const getgridDatAnalisis = () => pageApi.getComponent("gridDatAnalisis");
    const getgridDatAnalisisMain = () => pageApi.getComponent("gridDatAnalisisMain");
    const getForm = () => pageApi.getComponent("formSumas");
    const getForm_2 = () => pageApi.getComponent("form");
    const getGridResumen = () => pageApi.getComponent("ResumenSection");
    const getFormResumen = () => pageApi.getComponent("formResumen");
  
    const AnalisisModalConfig = (data) => {
      let obj = null;

      if (data) {
        obj = {
          descripcion: data?.descripcion_grupo,
          cantidad: data?.cantidad_puntos,
          frecuencia: data?.frecuencia,
          id_tipo_matriz: data?.id_producto,
          id_matriz: data?.id_mat,
        }
      }

      return {
        width: 950,
        maskClosable: false,
        component: (
          <DatosAnalisisModal
            name={obj}
            getParentApi={pageApi.getApi}
            config={analisisConfig}
          />
        ),
      };
    };

    const fnDelete = (value, row, index) => {
      const detalle = JSON.parse(row.detalles || '{}');
      const detalleIds = Array.from(detalle, el => el.id_rel_cot_ana || el.id_detalle_tarifa);
      let dataFilter = getgridDatAnalisisMain().getData();
      
      dataFilter = dataFilter.filter(el => detalleIds.includes(el.id_rel_cot_ana || el.id_detalle_tarifa));
      
      getgridDatAnalisis().deleteItem(row.key);
      dataFilter.forEach(el => getgridDatAnalisisMain().deleteItem(el.key))
    }

    const analisisConfig = {
      events: {
        afterAddEvent: (data) => {
          let datos_grid = getgridDatAnalisis().getData();
          let datos_grid_main = getgridDatAnalisisMain().getData();
          let find_data = datos_grid_main.find(
            (x) =>
              x.id_detalle_tarifa === data.id_detalle_tarifa &&
              x.descripcion_grupo === data.descripcion_grupo
          );

          if (find_data)
            return MessageUtil("warning", "Alerta!", "Ya Seleccionó el Item");

          let grupoExiste = datos_grid.find(el => 
            el.descripcion_grupo === data.descripcion_grupo &&
            el.producto_matriz === data.producto_matriz &&
            el.mat_nombre === data.mat_nombre 
            // el.cantidad_puntos === data.cantidad_puntos &&
            // el.simb_moneda === data.simb_moneda 
          )

          if (grupoExiste) {
            const detalle = JSON.parse(grupoExiste.detalles);
            detalle.push({
              tipo_ensayo: data.analisis,
              norma_referencia: data.norma_referencia,
              acreditacion: data.acreditador,
              sub_total: data.sub_total,
              cantidad_puntos: data.cantidad_puntos,
              simb_moneda: data.simb_moneda,
              id_detalle_tarifa: data.id_detalle_tarifa,
            })
            grupoExiste.detalles = JSON.stringify(detalle)
            grupoExiste.sub_total = parseFloat(grupoExiste.sub_total) + parseFloat(data.sub_total)
            grupoExiste.cantidad_puntos = parseInt(grupoExiste.cantidad_puntos) > parseInt(data.cantidad_puntos) ? grupoExiste.cantidad_puntos : data.cantidad_puntos;
            getgridDatAnalisis().updateItem(grupoExiste); 
            getgridDatAnalisis().refresh();

          } else {
            grupoExiste = {
              frecuencia: data?.frecuencia,
              id_producto: data?.id_tipo_matriz,
              id_mat: data?.id_matriz,
              descripcion_grupo: data.descripcion_grupo,
              producto_matriz: data.producto_matriz,
              mat_nombre: data.mat_nombre,
              sub_total: data.sub_total,
              cantidad_puntos: data.cantidad_puntos,
              simb_moneda: data.simb_moneda,
              detalles: JSON.stringify([
                {
                  tipo_ensayo: data.analisis,
                  norma_referencia: data.norma_referencia,
                  acreditacion: data.acreditacion,
                  sub_total: data.sub_total,
                  simb_moneda: data.simb_moneda,
                  cantidad_puntos: data.cantidad_puntos,
                  id_detalle_tarifa: data.id_detalle_tarifa,
                }
              ])
            }
            getgridDatAnalisis().addItem(grupoExiste); 
            getgridDatAnalisis().refresh();
          }

          getgridDatAnalisisMain().addItem(data); 
          
          return MessageUtil("success", "Item agregado correctamente!", "");
        },
      },
    };

    const calculateTotal = () => {
      let items = getgridDatAnalisisMain().getData();
      if (items) {
        let total = 0;
        let simb_moneda = "";

        items.forEach((item) => {
          total =
            total +
            (isNaN(parseFloat(item.sub_total)) ? 0 : parseFloat(item.sub_total));

          simb_moneda = item.simb_moneda;
        });

        let total_analisis = parseFloat(total);
        console.log(items);
        getForm().setData({
          sub_total_analisis: simb_moneda + ' ' + (isNaN(total_analisis) ? 0 : total_analisis.toFixed(2)).toString()
        });
        console.log(simb_moneda)

        let data_resumen = getGridResumen()
          ?.getData()
          ?.map((x, i) => {
            if (i === 0) {
              x.costo_servicio = total_analisis.toFixed(2);
              if (x.porcentaje === 0) {
                x.servicio_con_descuento = parseFloat(x.costo_servicio).toFixed(
                  2
                );
              } else {
                x.descuento =
                  (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje)) / 100;
                x.servicio_con_descuento =
                  parseFloat(x.costo_servicio) -
                  (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje)) / 100;
              }
              getFormResumen().setFieldData(
                "servicio_analisis",
                isNaN(parseFloat(x.servicio_con_descuento))
                  ? 0
                  : parseFloat(x.servicio_con_descuento).toFixed(2)
              );
            }
            return x;
          });
        getGridResumen()?.setData(data_resumen);

        let data_resumen_total = getGridResumen()
          ?.getData()
          ?.map((x, i) => {
            let total_resumen =
              parseFloat(getGridResumen()?.getData()[0].servicio_con_descuento) +
              parseFloat(getGridResumen()?.getData()[1].servicio_con_descuento);
            if (i === 2) {
              x.costo_servicio = parseFloat(total_resumen).toFixed(2);
              if (x.porcentaje === 0) {
                x.servicio_con_descuento = parseFloat(x.costo_servicio).toFixed(
                  2
                );
              } else {
                x.descuento =
                  (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje)) / 100;
                x.servicio_con_descuento =
                  parseFloat(x.costo_servicio) -
                  (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje)) / 100;
              }
              getFormResumen().setFieldData(
                "total_neto",
                isNaN(parseFloat(x.servicio_con_descuento))
                  ? 0
                  : parseFloat(x.servicio_con_descuento).toFixed(2)
              );
              let total_servicio = parseFloat(
                parseFloat(x.servicio_con_descuento) * 1.18
              );
              getFormResumen().setFieldData(
                "igv",
                isNaN(parseFloat(parseFloat(x.servicio_con_descuento) * 0.18))
                  ? 0
                  : parseFloat(
                      parseFloat(x.servicio_con_descuento) * 0.18
                    ).toFixed(2)
              );
              getFormResumen().setFieldData(
                "total_servicio",
                isNaN(total_servicio) ? 0 : total_servicio.toFixed(2)
              );
            }
            return x;
          });
        getGridResumen()?.setData(data_resumen_total);
      }
    };

    const barHeaderDatAnalisisConfig = {
      fields: [  
        {
          ...BUTTON_DEFAULT.SEARCH,
          label: "Agregar",
          onClick: () => { 
              pageApi.showModal(AnalisisModalConfig()); 
          },
        },
      ],
    };
 
    const eliminarParametro = (param, data) => {
      
      if (param.id_rel_cot_ana) {
        let updateData = data;
        let arrParametros = JSON.parse(data.detalles);
        arrParametros = arrParametros.filter(el => el.id_rel_cot_ana != param.id_rel_cot_ana);
        
        updateData = {
          ...updateData,
          detalles: JSON.stringify(arrParametros)
        }
        
        getgridDatAnalisis().updateItem(updateData);
        const dataMain = getgridDatAnalisisMain().getData();
        const itemElim = dataMain.find(el => el.id_rel_cot_ana == param.id_rel_cot_ana);
        getgridDatAnalisisMain().deleteItem(itemElim.key);
      } 
      else {
        let updateData = data;
        let arrParametros = JSON.parse(data.detalles);
        arrParametros = arrParametros.filter(el => el.id_detalle_tarifa != param.id_detalle_tarifa);
        
        updateData = {
          ...updateData,
          detalles: JSON.stringify(arrParametros)
        }

        getgridDatAnalisis().updateItem(updateData);
        const dataMain = getgridDatAnalisisMain().getData();
        const itemElim = dataMain.find(el => el.id_detalle_tarifa == param.id_detalle_tarifa);
        console.log(itemElim)
        getgridDatAnalisisMain().deleteItem(itemElim.key);
      }
    }

    const gridDatAnalisis = {
      title: "Datos de los Análisis",
      rowId: "id_rel_cot_ana",
      showIndex: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      autoLoad: true,
      collapsible: true,
      orderBy: "descripcion_grupo",
      load: {
        validation: () => pageApi.getParamId() != null, //solo se dispara si el valor es distinto de nulo
        queryId: 842,
        params: { id_doc: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {
          calculateTotal();
        },
      },
      addItem: {
        fnAfter: (row) => {
          calculateTotal();
        },
      },
      updateItem: {
        fnAfter: (row) => {
          calculateTotal();
        },
      },
      expandable: (record) => {
        const dataParam = JSON.parse(record.detalles || '[]')

        return (
          <table>
            <thead>
              <tr>
                <th>Parámetro</th>
                <th>Norma Referencia</th>
                <th>Puntos</th>
                <th>Acreditacion</th>
                <th>Sub Total</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              {
                dataParam.map(el => (
                  <tr>
                    <td>{el.tipo_ensayo}</td>
                    <td>{el.norma_referencia}</td>
                    <td>{el.cantidad_puntos}</td>
                    <td>{el.acreditacion}</td>
                    <td>{el.simb_moneda}  {el.sub_total}</td>
                    <td>
                      <Popconfirm
                        title={"¿Esta seguro que desea eliminar el registro?"}
                        onCancel={() => {}}
                        onConfirm={() => eliminarParametro({ 
                          id_rel_cot_ana: el.id_rel_cot_ana,
                          id_detalle_tarifa: el.id_detalle_tarifa,
                        }, record)}
                      >
                        <span className="button-fw-icon" style={{color: 'red', textAlign: 'center'}}>
                          {ICON.DELETE}
                        </span>
                      </Popconfirm>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )
      },
      fields: [
        { name: "descripcion_grupo", label: "Descripcion" },
        // {name: 'item', label:'Item'},
        { name: "producto_matriz", label: "Producto" },
        { name: "mat_nombre", label: "Matriz" },
        {
          type: "number",
          name: "cantidad_puntos",
          label: "Cantidad Puntos", 
          value: 1,
          onChange: (value, values, formApi) => {
            let cantidad_puntos = parseInt(values["cantidad_puntos"]);
            let frecuencia = parseInt(values["frecuencia"]);
            let precio_venta = parseFloat(values["precio_venta"]);
            let cbo_aplica = values["cbo_aplica"];
            let repeticiones = parseInt(values["repeticiones"]);
  
            if (cbo_aplica === 'Si') {
              let sub_total = (cantidad_puntos * frecuencia * repeticiones * precio_venta).toFixed(
                2
              );

              let precio_lista = parseFloat(values["precio_lista"]);

              formApi?.setFieldData("precio_lista", precio_lista.toFixed(2)); 
              formApi?.setFieldData("sub_total", sub_total);
              formApi?.setFieldData("repeticiones", repeticiones);
              formApi?.setFieldData("cbo_aplica", cbo_aplica);

              getgridDatAnalisisMain().refresh();
            } else {
              let sub_total = (cantidad_puntos * frecuencia * precio_venta).toFixed(
                2
              );
              let precio_lista = parseFloat(values["precio_lista"]); 

              formApi?.setFieldData("precio_lista", precio_lista.toFixed(2)); 
              formApi?.setFieldData("sub_total", sub_total); 

              getgridDatAnalisisMain().refresh();
            }
  
          },
        },
        { name: "simb_moneda", label: "Moneda" },
        {
          type: "decimal",
          name: "sub_total",
          label: "Total",
          // editable: true,
          readOnly: true,
        },
        {
          ...COLUMN_DEFAULT.EDIT,
          label: "Opciones",
          title: "Editar",
          color: "blue",
          colSpan: 2,
          onClick: (value, row) => {
            pageApi.showModal(AnalisisModalConfig(row)); 
          },
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          title: "Eliminar",
          color: "red",
          colSpan: 2,
          onClick: fnDelete,
        },
      ],
      barHeader: barHeaderDatAnalisisConfig,
    };

    const gridDatAnalisisMain = {
      title: "Datos de los Análisis",
      rowId: "id_rel_cot_ana",
      showIndex: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      autoLoad: true,
      collapsible: true,
      orderBy: "descripcion_grupo",
      load: {
        validation: () => pageApi.getParamId() != null, //solo se dispara si el valor es distinto de nulo
        queryId: 194,
        params: { id_doc: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {
          calculateTotal();
        },
      },
      save: {
        queryId: 193,
        params: { 
          id_doc: pageApi.getParamId(), est_tab : 3, id_user: UserUtil.getUserId()
          },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {
          calculateTotal();
          const id = this.props.match.params.id || 0;
          if (parseInt(id) > 2) {
            this.props.cambiarTabPanel("3",pageApi.getParamId()); 
          } else {
            this.props.history.push(`/cotizaciones/cotizaciones/3/${pageApi.getParamId()}`)
            this.props.cambiarTabPanel("3",pageApi.getParamId()); 
          }
          
          return MessageUtil(
            "success",
            "Exito!",
            "Se ha habilitado Datos del Proyecto"
          ); 
        },
      },
      addItem: {
        fnAfter: (row) => {
          calculateTotal();
        },
      },
      updateItem: {
        fnAfter: (row) => {
          calculateTotal();
        },
      },
      fields: [
        { name: "descripcion_grupo", label: "Descripcion" },
        // {name: 'item', label:'Item'},
        { name: "producto_matriz", label: "Producto" },
        { name: "mat_nombre", label: "Matriz" },
        {
          type: "number",
          name: "cantidad_puntos",
          label: "Cantidad Puntos", 
          value: 1,
          onChange: (value, values, formApi) => {
            let cantidad_puntos = parseInt(values["cantidad_puntos"]);
            let frecuencia = parseInt(values["frecuencia"]);
            let precio_venta = parseFloat(values["precio_venta"]);
            let cbo_aplica = values["cbo_aplica"];
            let repeticiones = parseInt(values["repeticiones"]);
  
            if (cbo_aplica === 'Si') {
              let sub_total = (cantidad_puntos * frecuencia * repeticiones * precio_venta).toFixed(
                2
              );

              let precio_lista = parseFloat(values["precio_lista"]);

              formApi?.setFieldData("precio_lista", precio_lista.toFixed(2)); 
              formApi?.setFieldData("sub_total", sub_total);
              formApi?.setFieldData("repeticiones", repeticiones);
              formApi?.setFieldData("cbo_aplica", cbo_aplica);

              getgridDatAnalisisMain().refresh();
            } else {
              let sub_total = (cantidad_puntos * frecuencia * precio_venta).toFixed(
                2
              );
              let precio_lista = parseFloat(values["precio_lista"]); 

              formApi?.setFieldData("precio_lista", precio_lista.toFixed(2)); 
              formApi?.setFieldData("sub_total", sub_total); 

              getgridDatAnalisisMain().refresh();
            }
  
          },
        },
        {
          type: "decimal",
          name: "sub_total",
          label: "Total",
          readOnly: true,
        },
        {
          ...COLUMN_DEFAULT.DELETE,
          label: "Opciones",
          title: "Eliminar",
          color: "red",
          colSpan: 2,
          onClick: fnDelete,
        },
      ],
      barHeader: barHeaderDatAnalisisConfig,
    };
  
    function extraerNumero(monto) {
      if (!monto || typeof monto !== 'string') return 0;
      const match = monto.match(/[\d.,]+/);
      if (!match) return 0;
      const numero = parseFloat(match[0].replace(',', ''));
      return isNaN(numero) ? 0 : numero;
    }

    const barButtonFooter_DatAnalisis = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN, link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE,label: 'Guardar y Continuar', onClick: () => { getgridDatAnalisisMain().save({ params: {
              id_doc: pageApi.getParamId(), 
              est_tab : 3, 
              id_user: UserUtil.getUserId(),
              sub_total: extraerNumero(getForm()?.getData()?.sub_total_analisis || 0)
            }})}}, 
        ]
    }

    const form_sumas = {
      fields: [
      {
      type: "text",
      name: "sub_total_analisis",
      label: "Sub Total",
      column: 12,
      readOnly: true,
      },
      ],
    };

    return (
      <> 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_DatAnalisis} 
        /> 
        <GridFw
          name="gridDatAnalisis"
          getParentApi={pageApi.getApi}
          config={gridDatAnalisis}
        />
        <div style={{ display: 'none' }}>
          <GridFw
            name="gridDatAnalisisMain"
            getParentApi={pageApi.getApi}
            config={gridDatAnalisisMain}
          />
        </div>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            
            <Col className="gutter-row" style={{ marginLeft: 'auto' }} span={32}>
              <FormFw
                  name="formSumas"
                  getParentApi={pageApi.getApi}
                  config={form_sumas}
              />
            </Col>
        </Row>
      </>
    ); 
  }
}

export default withRouter(DatosAnalisisSection)